import service from "../../services/gestionTiempos/assignCard";
import cards from "../../models/gestionTiempos/cards";

export default {
  namespaced: true,
  state: {
    service: new service(),
    date: null,
    cards: [],
    new: {},
    cardAssign: [],
    deleteItem: {},
    editItems: [],
    bookingError: [],
    repairError: {},
  },
  mutations: {
    setCards(state, data) {
      state.cards = data.item;
    },
    setDate(state, data) {
      state.date = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setCardsAssign(state, data) {
      state.cardAssign = data.item;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
    setBookingError(state, data) {
      state.bookingError = data;
    },
    setRepairError(state, data) {
      state.repairError = data;
    },
  },
  actions: {
    async getCards({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getCards();
        commit("setCards", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async getCardsAssign({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getCardsAsign();
        commit("setCardsAssign", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async newCard({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then((data) => {
            let items = state.new;
            let options = state.cards;

            let newItem = cards.fromJson({
              EmpId: data.data.empId,
              TarjId: items.cardId,
              FecDesde: items.from,
              FecHasta: items.to,
              OperId: data.data.operId,
              Id: data.id,
              Tarjeta: items.card == null ? null : items.card.trim(),
            });

            options.push(newItem);
            commit("setCards", { item: options });
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async deleteCard({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            let options = state.cards;
            options = options.filter((option) => {
              return option.cardId != state.deleteItem.tarjId;
            });

            commit("setCards", { item: options });
            resolve(true);
          });
        } catch (error) {
          reject(error.response.data);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.editItems).then(() => {
            let item = state.editItems;
            let options = state.cards;

            options = options.map((option) => {
              if (option.cardId != state.editItems.cardId) {
                return option;
              }

              item = cards.fromJson({
                TarjId: item.cardId,
                FecDesde: item.from,
                FecHasta: item.to,
                Tarjeta: item.card,
              });
              return item;
            });

            commit("setCards", { item: options });
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getBookingError({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getBookingErros(state.bookingError);
        commit("setBookingError", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async repairError({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.repairError(state.repairError).then(() => {
            let items = state.repairError;

            commit("setRepairError", items);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
